import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslocoService} from "@ngneat/transloco";

export class PaginatorIntlService extends MatPaginatorIntl {
    translate: TranslocoService;
    itemsPerPageLabel = 'Items per page';
    nextPageLabel = 'Next page';
    previousPageLabel = 'Previous page';
    getRangeLabel = function (page, pageSize, length) {
        const of = this.translate ? this.translate.translate('OF') : 'of';
        if (length === 0 || pageSize === 0) {
            return '0 ' + of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
    };

    injectTranslateService(translate: TranslocoService) {
        this.translate = translate;

        this.translate.langChanges$.subscribe((lang) => {

            // Hack in order for the user to change upon initialization
            setTimeout(() => {
                this.translateLabels();
            }, 10)

        })

        this.translateLabels();
    }

    translateLabels() {
        this.itemsPerPageLabel = this.translate.translate('ITEMS_PER_PAGE_LABEL');
        this.nextPageLabel = this.translate.translate('NEXT_PAGE_LABEL');
        this.previousPageLabel = this.translate.translate('PREVIOUS_PAGE_LABEL');
        this.changes.next();
    }

}
